import { FC } from "react";
import styled from "styled-components";
import { FirstPageDarkIcon, FirstPageGreyIcon, NextPageDarkIcon, NextPageGreyIcon, PreviousPageDarkIcon, PreviousPageGreyIcon } from "./pagingIcons";
import { useTheme } from "../../../features/context/CustomerContext";
import useCustomTranslation from "../../../features/hooks/CustomUseTranslation";

export const PageSelectionWrapper = styled.div`
    display: flex;
    margin-bottom: 20px;   
    float: right;
    @media screen and (max-width: ${(props) => props.theme.mobileTableBreakPoint}px) {
        justify-content: space-between; 
        width: 100%;
    }
`
export const PageLabelWrapper = styled.div`
    display: flex;
    flex-direction: row;
`
export const PageSelectionLabel = styled.div`
    margin-right: 15px;
    margin-left: 15px;
`
export const PageSelectionButton = styled.button`
    background-color: white;
    border: none;
    margin-left: 20px;
`

interface PageSelectionProps {
    pageNumber: number;
    totalPages: number;
    changePage: (newPage: number) => void;
}

const PageSelection:FC<PageSelectionProps> = (props) => {
    const { t } = useCustomTranslation();
    const theme = useTheme();
    
    function nextPage() {
        props.changePage(props.pageNumber + 1);
    }

    function previousPage() {
        props.changePage(props.pageNumber - 1);
    }

    function firstPage() {
        props.changePage(1);
    }
    
    return(
        <PageSelectionWrapper theme={theme}>
            <PageLabelWrapper>
                <PageSelectionButton aria-labelledby="firstPageButton" id="firstPageButton" disabled={ props.pageNumber < 2 } onClick={ () => firstPage()}>
                    {(props.pageNumber < 2) ? <FirstPageGreyIcon /> : <FirstPageDarkIcon />}
                </PageSelectionButton>

                <PageSelectionLabel>
                {t("Page")} { props.pageNumber } / { props.totalPages === 0 ? 1 : props.totalPages }
                </PageSelectionLabel>
            </PageLabelWrapper>
            <div>
                <PageSelectionButton aria-labelledby="previousPageButton" id="previousPageButton" disabled={ props.pageNumber < 2 } onClick = { () => previousPage()}>
                    {(props.pageNumber < 2) ? <PreviousPageGreyIcon /> : <PreviousPageDarkIcon />}
                </PageSelectionButton>

                <PageSelectionButton aria-labelledby="nextPageButton" id="nextPageButton" disabled={ props.pageNumber >= props.totalPages} onClick = { () => nextPage()}>
                    { props.pageNumber >= props.totalPages ? <NextPageGreyIcon /> : <NextPageDarkIcon />}
                </PageSelectionButton>
            </div>
        </PageSelectionWrapper>
    )
}

export default PageSelection;